import { Card } from '../../Common/Charts/Card';
import { QUERY_KEYS_CIHA, useChartsData } from './hooks/useChartsData';
import { useCIHAFiltersContext } from './Filters/hooks/useCIHAFiltersContext';
import { number } from '../../Common/Util/number';

export const ProductionKpis = () => {
    const { filters } = useCIHAFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
        cnes: filters.unidade?.value,
        ano: filters.year?.value || currentYear,
        mes: filters.month?.value
    };

    const { data } = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PRODUCTION_KPI,
            url: 'governanceroom/cihadashboard/kpiProduction'
        },
        filterParams
    );

    const kpi = data?.values || {};
    const comparison = data?.comparacaoAnoAnterior || {};

    return (
        <div className="kpi-row-ciha">
            <Card
                title={'Total de Atendimentos'}
                value={number.formatToBRNumber(kpi.total_atendimentos)}
                variation={comparison.total_atendimentos_variacao_pct}
                comparativeSubtitle="Ano anterior"
            />
            <Card
                title={'Média de Permanência'}
                value={number.formatToBRNumber(kpi.media_permanencia)}
                variation={comparison.media_permanencia_variacao_pct}
                invertTrendColor
                comparativeSubtitle="Ano anterior"
            />
            <Card
                title={'Taxa de Mortalidade'}
                value={
                    kpi.taxa_mortalidade === undefined || kpi.taxa_mortalidade === null
                        ? '-'
                        : number.formatToPercentage(kpi.taxa_mortalidade)
                }
                variation={comparison.taxa_mortalidade_variacao_pct}
                invertTrendColor
                comparativeSubtitle="Ano anterior"
            />
            <Card
                title={'CNES'}
                value={number.formatToBRNumber(kpi.total_cnes_unicos)}
                variation={comparison.total_cnes_unicos_variacao_pct}
                comparativeSubtitle="Ano anterior"
            />
            <Card
                title={'Municípios'}
                value={number.formatToBRNumber(kpi.total_municipios)}
                variation={comparison.total_municipios_variacao_pct}
                comparativeSubtitle="Ano anterior"
            />
            <Card
                title={'Procedimentos Distintos'}
                value={number.formatToBRNumber(kpi.total_procedimentos_distintos)}
                variation={comparison.total_procedimentos_distintos_variacao_pct}
                comparativeSubtitle="Ano anterior"
            />
        </div>
    );
};
